export default __webpack_public_path__ + "static/media/mike lawler.21e3190f.jpg";